"use strict";

import * as App from '../app/app~fv=cw_byBD8.min.js';

/**@typedef {import('../app/paginate.js').PagRec} PagRec */

App.AddOnload(CommentOnLoad);

async function CommentOnLoad() {
	// Response comes directly from template/server on load.
	/**@type {PagRec} */
	var pagrec = await App.InitPagRec(response);
	console.debug(pagrec)
	// Comments don't have checkboxes. Hide even if logged in.
	document.querySelectorAll('.table_delete_btn').forEach((item) => Hide(item));

	// Set headers and header links for pages.
	if (!isEmpty(pagrec.pag) && !isEmpty(pagrec.pag.subject_value)) {
		let subjectHeader = document.querySelector('.headerLink');
		let header = subjectHeader;
		if (pagrec.pag.subject === "uad") {
			header = document.querySelector(".userHeaderLink");
			Hide(subjectHeader);
			Show(document.querySelector("#userLink"));
		} else if (pagrec.pag.subject === "parent") {
			if (!isEmpty(pagrec.rec)) {
				header = document.querySelector(".parentHeaderLink");
				subjectHeader.innerHTML = pagrec.rec[0].root.link("/s/" + pagrec.rec[0].root);
				Show(document.querySelector("#parentLink"));
			}
		}
		header.innerHTML = pagrec.pag.subject_value.link("/s/" + pagrec.pag.subject_value);
	}

	// Create comments and append to the GUI
	App.CommentReviewModule(pagrec);

	// Highlight comment from search/url.

	// Verb is the id for the url on the comments page. On user comments page, the
	// verb is the user's uad, and does not highlight any comments since the id
	// cannot be a comment on the page.
	let currentCommentFromSearch = document.getElementById(GetLastPath(window.location.toString()));
	if (currentCommentFromSearch != null) {
		currentCommentFromSearch.classList.add("highlight");
	}
};


// TODO Put this function where it belongs
// Gets the last part of the uri path.
// This is everything before the fragment, and query, and everything after the
// last slash.
function GetLastPath(s) {
	let afterSlash = s.substring(s.lastIndexOf('/') + 1);
	let beforeQuery = afterSlash.split("?")[0];
	return beforeQuery.split("#")[0]; // for fragments
}